export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/a979dbc745f4-tooliconnumber2.jpg',
  },
  title: 'What is the product name/model number?',
  placeholderText: 'e.g. 65UL2063DB 65" Smart 4K Ultra HD TV',
}
